import type { IBoundingboxViewer3dItem } from "../RoomSectionViews/types";

export const getInitialCameraZ = (cameraZ: number | undefined, minGeometryZ: number): number =>
  cameraZ != null && Number.isFinite(cameraZ) ? cameraZ : minGeometryZ + 1.65;

export const createRenderItemsKey = (
  items: IBoundingboxViewer3dItem[],
): string =>
  JSON.stringify(
    items.map(({ item, color, opacity, outline }) => [
      item.globalId ?? item._id,
      color,
      opacity,
      outline,
      item.geometry,
    ]),
  );
